/** Coerces a data-bound value (typically a string) to a boolean. */
/** Coerces a data-bound value (typically a string) to a boolean. */ export function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}
//# sourceMappingURL=boolean-property.js.map


//////////////////
// WEBPACK FOOTER
// ./~/md2/core/coercion/boolean-property.js
// module id = 61
// module chunks = 3